import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = require("@/router/routes").default;

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

window.router = router;
export default router;
